import React from "react";
import { 
  MapPin, 
  Phone, 
  Mail, 
  Clock, 
  Facebook, 
  Instagram, 
  Youtube 
} from "lucide-react";
import PublicNavbar from "../components/PublicNavbar";

export default function Location() {
  return (
    <div className="bg-white text-[#1e3a8a] font-sans mb-4">
      <PublicNavbar />

      <main className="max-w-7xl mx-auto p-4 md:p-8 lg:mb-10 lg:p-12">
        {/* Header Badge */}
        <div className="flex justify-center mb-5 md:mb-7 px-4">
          {/* The Wrapper for the offset shadow effect */}
          <div className="relative inline-block">
            
            {/* Lime Green Shadow Layer (Offset background) */}
            <div className="absolute inset-0 bg-[#c5e153] translate-x-[-4px] translate-y-[8px] rounded-3xl md:rounded-[2rem]" />

            {/* Main Blue Badge */}
            <div className="relative flex items-center gap-3 bg-[#074b85] text-white px-6 py-3 md:px-10 md:py-4 rounded-3xl md:rounded-[2rem] shadow-sm">
              {/* Pin Icon Container */}
              <div className="flex-shrink-0">
                <img 
                  src="/newassets/pin.png" 
                  alt="Location Pin" 
                  className="w-5 h-7 md:w-8 md:h-10 object-contain" 
                />
              </div>
              
              {/* Text */}
              <span className="font-extrabold text-2xl md:text-4xl tracking-tight uppercase leading-none">
                Location
              </span>
            </div>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row gap-0 lg:gap-8 items-start">
          
          {/* Left Side: The Map Area */}
          <div className="w-full lg:w-2/3 bg-gray-100 overflow-hidden border-4 border-white">
            <img
              src="/newassets/map.jpg"
              alt="CamSur Pickleball Location Map"
              className="w-full h-auto object-cover"
            />
          </div>

          {/* Right Side: Info & Actions */}
          <div className="w-full lg:w-1/3 space-y-4 xl:space-y-8 lg:pt-[3vh] xl:pt-[5vh]">
            
            {/* Navigation Buttons */}
            <div className="space-y-2 xl:space-y-4">
              <a 
                href="https://waze.com" 
                target="_blank" 
                className="flex items-center justify-center gap-3 bg-[#fe7e01] hover:bg-[#e66500] text-white py-3 rounded-full font-bold transition-all shadow-md"
              >
                <img src="/newassets/waze.png" alt="Waze" className="w-9 h-9 lg:w-10 lg:h-10" />
                Drive with Waze
              </a>
              <a 
                href="https://maps.google.com" 
                target="_blank" 
                className="flex items-center justify-center gap-3 bg-[#fe7e01] hover:bg-[#e66500] text-white py-4 rounded-full font-bold transition-all shadow-md"
              >
                <img src="/newassets/google maps.png" alt="Google Maps" className="w-4 h-5 lg:w-6 lg:h-7" />
                Drive with Google Maps
              </a>
            </div>

            {/* Social Media */}
            <div className="flex flex-col items-center gap-2">
              <div className="flex gap-4">
                <img src="/newassets/fb.png" alt="Facebook" className="p-2 bg-[#064a85] rounded-lg w-10 h-10 cursor-pointer" />
                <img src="/newassets/insta.png" alt="Instagram" className="p-2 bg-[#064a85] rounded-lg w-10 h-10 cursor-pointer" />
                <img src="/newassets/utube.png" alt="YouTube" className="p-2 bg-[#064a85] rounded-lg w-10 h-10 cursor-pointer" />
                <img src="/newassets/tiktox.png" alt="TikTok" className="p-2 bg-[#064a85] rounded-lg w-10 h-10 cursor-pointer" />
              </div>
              <p className="font-semibold text-[#064a85] text-lg">@camsurpickleball</p>
            </div>

            {/* Contact Details */}
            <div className="space-y-6 text-[#064a85]">
              <div className="flex items-start gap-4">
                {/* <img src="/newassets/pinn.png" alt="Location" className="w-4 h-5" /> */}
                <span> 
                  <img 
                    src="/newassets/pinn.png" 
                    alt="Pin" 
                    className="w-6 h-6"
                    style={{ 
                      // This filter converts black to roughly #074b85
                      filter: 'invert(19%) sepia(94%) saturate(1831%) hue-rotate(188deg) brightness(91%) contrast(101%)' 
                    }} 
                  />
                </span>
                <p className="text-sm font-bold">
                  Fuerte CamSur Sports Complex, Capitol Complex, Cadlan, Pili, Camarines Sur.
                </p>
              </div>

              <div className="flex items-center gap-4 text-[#064a85]">
                <span >
                  <img 
                    src="/newassets/call.png" 
                    alt="Call" 
                    className="w-6 h-6"
                    style={{ 
                      // This filter converts black to roughly #074b85
                      filter: 'invert(19%) sepia(94%) saturate(1831%) hue-rotate(188deg) brightness(91%) contrast(101%)' 
                    }} 
                  />
                </span>
                <p className="text-sm font-bold">+63 918 905 2392</p>
              </div>

              <div className="flex items-center gap-4 text-[#064a85]">
                <span> 
                  <img 
                    src="/newassets/message.png" 
                    alt="Message" 
                    className="w-6 h-5"
                    style={{ 
                      // This filter converts black to roughly #074b85
                      filter: 'invert(19%) sepia(94%) saturate(1831%) hue-rotate(188deg) brightness(91%) contrast(101%)' 
                    }} 
                  />
                </span>       
                <p className="text-sm font-bold">camsurpickleball@gmail.com</p>
              </div>

              <div className="flex items-center gap-4 text-[#074b85]">
                <span> 
                  <img 
                    src="/newassets/oras.png" 
                    alt="Clock" 
                    className="w-6 h-6"
                    style={{ 
                      // 1. brightness(0) makes the green icon black
                      // 2. The rest shifts that black to exactly #074B85
                      filter: 'brightness(0) invert(20%) sepia(55%) saturate(3000%) hue-rotate(185deg) brightness(95%) contrast(105%)' 
                    }} 
                  />
                </span>
                <p className="text-sm font-bold uppercase tracking-tight">
                  Monday - Sunday - 6AM to 10PM
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}